export enum CurrentPosition {
  EntryLevel = 'entry_level',
  MidLevel = 'mid_level',
  SeniorLevel = 'senior_level',
  Executive = 'executive',
}
